module.exports = __webpack_public_path__ + "images/internal/datashake/booking_com.png";